import { SignedIn, SignedOut } from "@clerk/nextjs";
import { useRouter } from "next/compat/router";

import { AnnotationsPanel } from "./Annotations";
import BackupPaymentReminderModal from "./BackupPaymentReminderModal";
import BecomeAMemberModal from "./BecomeAMemberModal";
import Mounted from "./Mounted";
import OnboardingChecklistModal from "./OnboardingChecklistModal";
import PaymentDueDialog from "./PaymentDueDialog";
import PhoneNumberModal from "./PhoneNumberModal";
import SearchModal from "./SearchModal";
import SelectACertificationModal from "./SelectACertificationModal";
import SelectAProfessionModal from "./SelectAProfessionModal";
import ShareModal from "./ShareModal";
import SignInModal from "./SignInModal";
import SignUpModal from "./SignUpModal";
import WelcomeModal from "./WelcomeModal";
import type { BreadcrumbItem } from "~/components/Breadcrumbs";
import {
	shouldMountBecomeAMemberModal,
	shouldMountSignedInChromeModals,
} from "~/lib/shouldMountSignedInModals";
import { restrictedPaths } from "~/utils/constants";

interface ModalsProps {
	breadcrumbs?: BreadcrumbItem[];
}

const Modals = ({ breadcrumbs }: ModalsProps) => {
	const router = useRouter();
	const pathname = router?.pathname;
	const mountBecomeAMemberModal = shouldMountBecomeAMemberModal(pathname);
	const mountSignedInChromeModals = shouldMountSignedInChromeModals(
		pathname,
		restrictedPaths,
	);

	return (
		<Mounted>
			<PaymentDueDialog />
			{/*<UserSessionDialog />*/}

			<ShareModal />

			<SignedOut>
				<WelcomeModal />
				<SignUpModal />
				<SignInModal />
			</SignedOut>

			<SignedIn>
				{mountBecomeAMemberModal && <BecomeAMemberModal />}
				{mountSignedInChromeModals && (
					<>
						<BackupPaymentReminderModal />
						<SelectAProfessionModal />
						<SelectACertificationModal />
						<OnboardingChecklistModal />
						<PhoneNumberModal />
						<AnnotationsPanel hasBreadcrumbs={!!breadcrumbs} />
					</>
				)}
			</SignedIn>

			<SearchModal />
		</Mounted>
	);
};

export default Modals;
